import { ReactComponent as Icon } from "../files/link.svg";
import ISVGIconProps from "../ISVGIconProps";

const Link = ({ fill, style = {} }: ISVGIconProps) => {
    return <Icon fill={fill} style={style} />;
};

export default Link;
